// Crell to handle binary data display in tables

import React from 'react'
import _ from 'lodash'

import {Buffer} from 'buffer'

import {Cell} from 'fixed-data-table'

export const BufferCell = ({value, format, encoding, ...props}) => {
   let ret = BufferCell.format(BufferCell.decode(value, encoding), format)

   return (
      <Cell title={'Format: ' + format}>
         <span className={`buffer buffer-${format}`}>{ret}</span>
      </Cell>
   )
}

BufferCell.decode = (value, encoding) => new Buffer(value, encoding)

BufferCell.format = (buf, type) => {
   switch (type) {
      case 'hex':
         return BufferCell.toHex(buf)
      case 'ascii':
         return BufferCell.toAscii(buf)
      case 'bytes':
         return BufferCell.toBase10(buf)
      case 'base64':
         return BufferCell.toBase64(buf)
      case 'raw':
      default:
         return BufferCell.toRaw(buf)
   }
}

BufferCell.formats = ['ascii', 'hex', 'raw', 'base64', 'bytes']

const toNibble = c => ('0' + c.toString(16)).substr(-2)

const mapAscii = c => {
   switch (c) {
      case 7:
         return '\\a'
      case 8:
         return '\\b'
      case 9:
         return '\\t'
      case 10:
         return '\\n'
      case 11:
         return '\\v'
      case 12:
         return '\\f'
      case 13:
         return '\\r'
      default:
         return 32 > c || 177 <= c ? '\\0x' + toNibble(c) : String.fromCharCode(c)
   }
}

BufferCell.toHex = buf => _.map(buf, toNibble).join(' ')
BufferCell.toAscii = buf => _.map(buf, mapAscii).join('')
BufferCell.toBase10 = buf => _.map(buf, n => n.toString(10)).join(' ')
BufferCell.toBase64 = buf => buf.toString('base64')
BufferCell.toRaw = buf => buf.toString('binary')

BufferCell.propTypes = {
   value:    React.PropTypes.any,
   format:   React.PropTypes.oneOf(['hex', 'ascii', 'decimals', 'base64', 'raw', null]),
   encoding: React.PropTypes.oneOf(['base64', 'hex', 'binary'])
}

export default BufferCell



// WEBPACK FOOTER //
// lib/bundle/dashboard/query/BufferCell.jsx